import React from 'react';
import { ShieldCheck, AlertOctagon, HeartPulse } from 'lucide-react';
export function Safety() {
  return <section className="py-20 bg-white" data-id="element-255">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-256">
        <div className="bg-blue-50 border border-blue-100 rounded-2xl p-8 md:p-10" data-id="element-257">
          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-258">
            <div className="bg-blue-100 p-3 rounded-full flex-shrink-0" data-id="element-259">
              <ShieldCheck className="w-8 h-8 text-blue-600" data-id="element-260" />
            </div>
            <div data-id="element-261">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-262">
                Tu seguridad es nuestra prioridad
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-263">
                La cosmética natural mal hecha puede ser peligrosa. Un producto
                con agua sin el conservante adecuado es un caldo de cultivo para
                bacterias en 48 horas.
              </p>

              <div className="grid sm:grid-cols-2 gap-4" data-id="element-264">
                <div className="flex items-start gap-3" data-id="element-265">
                  <AlertOctagon className="w-5 h-5 text-[#C06C54] mt-0.5" data-id="element-266" />
                  <p className="text-sm text-gray-600" data-id="element-267">
                    Aprenderás por qué el "agua de rosas" casera se pudre rápido
                    y cómo evitarlo.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-268">
                  <HeartPulse className="w-5 h-5 text-[#C06C54] mt-0.5" data-id="element-269" />
                  <p className="text-sm text-gray-600" data-id="element-270">
                    Incluimos protocolos de "Prueba de Parche" para evitar
                    reacciones alérgicas.
                  </p>
                </div>
              </div>

              <div className="mt-6 p-4 bg-white rounded-lg border border-blue-100 text-sm text-blue-800 font-medium" data-id="element-271">
                Nota: Este libro promueve el uso responsable de conservantes
                naturales aprobados por Ecocert para garantizar tu salud.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}